<template>

    <el-form class="topicdetail">
      <el-form-item><p><span><i>*</i>课程：</span>{{examData.courseName}}</p></el-form-item>
      <el-form-item><p><span><i>*</i>题目：</span>{{examData.questionTitle}}</p></el-form-item>
      <div v-if="examData.questionType==1 || examData.questionType==2">
        <el-form-item><p><span><i>*</i>选项类型：</span>{{type}}</p></el-form-item>
        <el-form-item v-for="(item,index) in examData.answers">
          <p>
            <span><i>*</i>选项{{String.fromCharCode(65 + index)}}：</span>
            <label v-if="item.questionType==1 || item.type=='文字'">{{item.option}}</label>
            <img style="width: 200px;" v-else :src="item.option">
          </p>
        </el-form-item>
        <el-form-item><p><span><i>*</i>答案：</span>{{ answers }}</p></el-form-item>
      </div>
      <div v-else>
        <el-form-item style="display: flex;">
          <div class="item" style="width:100px;text-align: right">参考答案：</div>
          <div class="item" v-for="item of examData.answers" v-html="item.option"></div>
        </el-form-item>
      </div>
      <el-form-item style="margin:0px 30px 80px">
        <el-button type="primary" @click="$router.push({path:'/Education/questionentry',query:{questionId:questionId},replace: true})">修改</el-button>
        <el-button @click="questiondetail">返回</el-button>
      </el-form-item>
    </el-form>

</template>
<script>
export default ({
  name:'quesitiondetail',
  props:['questionId'],
  data(){
    return{
      examData:'',
      answers:'',
      type:''
    }
  },
  watch:{
    questionId:{
      handler:function(newval,oldval){
        this.questionId=newval;
        this.Detail();
      },
      deep:true
    }
  },
  mounted() {
    this.Detail();
  },
  methods:{
    questiondetail(){
      this.$emit('questiondetail')
    },
    // 详情
    Detail(){
      this.$Http_Get('edu/question/getInfo/'+this.questionId).then(res=>{
        if(res.Code==0){
          this.examData=res.Data;
          this.answers='';
          this.type=res.Data.answers[0].type;
          if(res.Data.questionType==1 || res.Data.questionType==2){
            for(var i=0;i<this.examData.answers.length;i++){
              if(this.examData.answers[i].answer==1){
                this.answers+=String.fromCharCode(65 + i);
              }
            }
            // for(let item of res.Data.answers){
            //   if(item.answer==1){
            //     this.answers+=item.answerOrder;
            //   }
            // }
            
          }
        }else{
          this.$message({type: 'error', message:'查询详情数据失败'});
        }
      })
    }
  }
})
</script>
<style scoped>
.topicdetail p{font-size: 16px;}
.topicdetail p span{text-align: right;width: 100px;display: inline-block;}
.topicdetail i{color: red;padding:0 5px;}
.topicdetail .item{display: table-cell;font-size: 16px;}
</style>